/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { RouteParams } from "~/models";
import { Contact } from "~/models/contact";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";

type ContactDeleteProps = {
  initialValues: Contact;
  deleteCallback?: () => void;
};

function ContactDelete({ initialValues, deleteCallback }: ContactDeleteProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const state = useParams<RouteParams>();
  const { customerId } = state;

  const name = initialValues?.name;

  const { showError } = useShowError();
  const { Axios } = useAxios();

  return (
    <>
      <Button
        icon="trash"
        size="sm"
        onClick={() => setIsOpen(true)}
        severity="low"
      >
        Delete
      </Button>
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(
              `/customers/${customerId}/contacts/${initialValues?.id}`
            );
            setIsOpen(true);
            deleteCallback && deleteCallback();
            showSuccess(
              generateActionSuccessText(`The ${name}`)()("deleted")()
            );
          } catch (e) {
            showError(e.response);
          } finally {
            setIsOpen(false);
          }
        }}
        actionLabel="Delete"
        contentLabel="Delete Contact"
      >
        {generateActionConfirmText(`${name}`)("delete")()} <br />
      </ModalConfirm>
    </>
  );
}

export { ContactDelete };
